import '../App.css'
import EditText from './EditText';
import Button from './Button';
import { useState } from 'react';
import { LOGIN } from '../Urls';
import { useAuth } from './AuthProvider';
import Password from './Password';
import { useNavigate } from 'react-router-dom';
import { overrideWindowAlert } from './Alert';

const Login = () => {
    overrideWindowAlert();
    const navigate = useNavigate(); 
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const { login } = useAuth();

    // Función para generar un token simple
    const generateToken = () => {
        return Math.random().toString(36).substring(2) + Date.now().toString(36);
    };

    const handleLogin = (event) => {
        event.preventDefault(); // Evita la recarga de la página

        const url = LOGIN;
        const dataToSend = { username, password };

        console.log("Posting to URL:", url);
        console.log("Data to send:", dataToSend);

        // Realiza la petición a la API
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataToSend)
        })
        .then(response => { // Verifica si la respuesta es ok
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(response => { // Maneja la respuesta de la API
            console.log(response);
            if (response.success) {
                // Generar token en el frontend ya que el backend no lo envía
                const token = generateToken();
                localStorage.setItem('token', token);
                
                // Iniciar sesión con los datos del usuario
                login(response.user, response.permissions || {});
                navigate('/home');
                //window.alert('Inicio de sesión exitoso');
            } else {
                window.alert('Error', 'Datos de inicio de sesión inválidos');
            }
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
            window.alert('Error de conexión', 'Inténtalo de nuevo');
        });
    };

    return ( // Renderiza el formulario de login
        <div className='login-container'>
            <form onSubmit={handleLogin}>
                <div className="login">
                    <div className='titleFont'>Login</div>
                        Usuario:
                        <div className='invisible-horizontal-container'>
                            <EditText text="Usuario" onChange={setUsername} />
                        </div>
                        Contraseña:
                        <div className='invisible-horizontal-container'>
                            <Password text="Introduce la contraseña" onChange={setPassword} />
                        </div>
                        <Button text="Acceder" color="#7AACE3" type="submit" />
                    </div>
            </form>
        </div>
    );
};

export default Login;